import React from "react";
import TimePicker from "rc-time-picker";
import classNames from "classnames/bind";
import styles from "./DateRangeSelector.module.scss";
import config from "../config";
import moment from "moment";
import { getTimeStringFromDate } from "../utils/timeFormatter";
import type {
  CalendarTimePickerProps,
  TimePickerContainerProps,
} from "./types";

const cx = classNames.bind(styles);

const TimePickerContainer = ({
  keyValue,
  title,
  value,
  onTimeChange,
  setIsTimePickerOpen,
}: TimePickerContainerProps) => {
  return (
    <div className={cx("timePickerContainer")}>
      <div>{title}</div>

      <div className={cx("timePickerDate")}>
        {getTimeStringFromDate(value, config.DATE_FORMAT)}
      </div>

      <TimePicker
        value={value}
        showSecond={false}
        allowEmpty={false}
        placement="bottomRight"
        onChange={(value) => onTimeChange(keyValue, value)}
        onOpen={() => setIsTimePickerOpen(true)}
        onClose={() => setIsTimePickerOpen(false)}
      />
    </div>
  );
};

const CalendarTimePicker = ({
  from,
  to,
  setIsTimePickerOpen,
  onTimeChange,
}: CalendarTimePickerProps) => {
  return (
    <div className={cx("calendarTimePicker")}>
      <TimePickerContainer
        title="From"
        keyValue="from"
        value={moment(from)}
        onTimeChange={onTimeChange}
        setIsTimePickerOpen={setIsTimePickerOpen}
      />

      <TimePickerContainer
        title="To"
        keyValue="to"
        value={moment(to)}
        onTimeChange={onTimeChange}
        setIsTimePickerOpen={setIsTimePickerOpen}
      />
    </div>
  );
};

export default CalendarTimePicker;
